import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import api from '../../utils/api';
import Drawer from 'material-ui/Drawer';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import NavigationBar from '../../components/NavigationBar';
import { Grid } from 'react-flexbox-grid';
import { push } from 'connected-react-router';
import Snackbar from 'material-ui/Snackbar';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import HelpIcon from 'material-ui/svg-icons/action/help';

import * as globalActions from '../../global/actions';

let SelectableList = makeSelectable(List);

import '../../styles/core.scss';

function wrapState(ComposedComponent) {
    return class SelectableList extends React.Component {
        static propTypes = {
            children: PropTypes.node.isRequired,
            defaultValue: PropTypes.number.isRequired,
        };

        componentWillMount() {
            this.setState({
                selectedIndex: this.props.defaultValue,
            });
        }

        handleRequestChange = (event, index) => {
            this.setState({
                selectedIndex: index,
            });
            this.props.handleRequestChange(index);
        };

        render() {
            return (
                <ComposedComponent
                    value={this.state.selectedIndex}
                    onChange={this.handleRequestChange}>
                    {this.props.children}
                </ComposedComponent>
            );
        }
    };
}

const mailto = 'mailto:scantouch@bstools.de?subject=Support%20Anfrage%20-%20ScanTouch';

SelectableList = wrapState(SelectableList);

class CoreLayout extends React.Component {
    static propTypes = {
        children: PropTypes.element.isRequired,
        routing: PropTypes.object,
        historyActions: PropTypes.object,
        navigationActions: PropTypes.object,
    };

    constructor(options) {
        super(options);
        this.state = {
            showNavigation: false,
        };
    }

    onRequestChangeList = route => {
        this.props.dispatch(push(route));
        this.toggleNavigation();
    };

    toggleNavigation = () => {
        if (localStorage.getItem('scantouch_token')) {
            this.setState({
                showNavigation: !this.state.showNavigation,
            });
        }
    };

    didCloseMessage = () => {
        this.props.hideMessage();
    };

    componentDidMount = () => {
        this.props.loadCurrentUser();
    };

    render = () => {
        const dockedLeftNavStyle = {
            paddingTop: '80px',
        };

        const undockedLeftNavStyle = {
            paddingTop: '80px',
        };

        const docked = this.props.deviceSize > 1 ? true : false;

        const isAuthenticated =
            localStorage.getItem('scantouch_token') !== undefined ? true : false;

        let settings = [
            <ListItem value="/settings/data_format">Warenwirtschaftssystem</ListItem>,
            <ListItem value="/device_guidelines">Gerätevorgaben</ListItem>,
        ];
        if (this.props.plan === 'pro') {
            settings.push(
                <ListItem value="/settings/customer_orders">Kundenbestellungen</ListItem>
            );
        }

        const helpButtonStyle = {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 100
        };

        return (
            <div style={{ paddingBottom: '50px' }}>
                <Snackbar
                    open={this.props.global.getIn(['message', 'show'])}
                    message={this.props.global.getIn(['message', 'text'], '')}
                    autoHideDuration={4000}
                    onRequestClose={this.didCloseMessage}
                />
                <NavigationBar
                    topBar
                    className="navigation-bar"
                    leftIcon="menu"
                    iconElementRight={this.props.tenant_name}
                    toggleNavigation={this.toggleNavigation}
                    showNavigation={!docked}
                />
                <Drawer
                    ref="leftNav"
                    style={docked ? dockedLeftNavStyle : undockedLeftNavStyle}
                    docked={docked}
                    open={this.state.showNavigation}>
                    <NavigationBar
                        topBar={false}
                        className="navigation-bar"
                        leftIcon="close"
                        toggleNavigation={this.toggleNavigation}
                        showNavigation
                    />
                    <SelectableList
                        // defaultValue={parseInt(this.props.location.pathname)}
                        defaultValue={0}
                        handleRequestChange={this.onRequestChangeList}>
                        <ListItem value="/branches" primaryText="Filialen" />
                        <ListItem value="/receipts">Belege</ListItem>
                        <ListItem
                            primaryText="Einstellungen"
                            initiallyOpen
                            primaryTogglesNestedList
                            nestedItems={settings}
                        />
                        <Divider />
                        <ListItem value="/subscriptions/list" primaryText="Software-Abos" />
                        <ListItem value="/account">Rechnungsadresse & Rechnungen</ListItem>
                        <Divider />
                        <ListItem
                            value="/logout"
                            primaryText="Abmelden"
                            disabled={!isAuthenticated}
                        />
                    </SelectableList>
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            padding: '8px 16px',
                            fontSize: '11px',
                            lineHeight: '14px',
                            color: '#9e9e9e',
                            boxSizing: 'border-box',
                        }}>
                        {typeof __BUILD_INFO__ !== 'undefined' ? __BUILD_INFO__ : ''}
                    </div>
                </Drawer>
                <Grid>{this.props.children}</Grid>
                <a href={mailto}>
                    <FloatingActionButton
                        style={helpButtonStyle}
                        tooltip="Hilfe/Kontakt"
                        tooltipPosition="top-center"
                    >
                        <HelpIcon />
                    </FloatingActionButton>
                </a>
            </div>
        );
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadCurrentUser: () => dispatch(api.actions.user.currentUser()),
        navigationActions: () => {},
        showMessage: payload => dispatch(globalActions.showMessage(payload)),
        hideMessage: () => dispatch(globalActions.hideMessage()),
        dispatch,
    };
}

function mapStateToProps(state, props) {
    return {
        auth: state.auth,
        global: state.global,
        plan: state.user.get('plan'),
        tenant_name: state.user.getIn(['tenant_name'], ''),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CoreLayout);
